import React, { useEffect, useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import authCopy from "../data/private/auth.json";
import { useAuth } from "../context/AuthContext";
import { logActivity } from "../utils/activity";

export default function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [sessionMessage, setSessionMessage] = useState("");
  const navigate = useNavigate();
  const { login } = useAuth();

  useEffect(() => {
    try {
      const message = localStorage.getItem("myv_session_expired_message");
      if (message) {
        setSessionMessage(message);
        localStorage.removeItem("myv_session_expired_message");
      }
    } catch (error) {
      // no-op
    }
  }, []);

  const emailValue = email.trim();
  const isValidEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(emailValue);
  const isValid = isValidEmail && password.trim().length >= 4;

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (isSubmitting) {
      return;
    }
    setError("");
    setIsSubmitting(true);
    const result = await login(emailValue, password.trim());
    if (!result.ok) {
      setError(result.message || authCopy.login.error);
      setIsSubmitting(false);
      return;
    }
    logActivity("auth_login", { email: emailValue });
    navigate("/otp-verification");
  };

  return (
    <div className="min-h-screen bg-slate-50">
      <section className="section-padding mx-auto w-full max-w-lg">
        <div className="card space-y-4 p-6">
          <h1 className="page-title text-2xl">{authCopy.login.title}</h1>
          <p className="text-sm text-slate-600">{authCopy.login.subtitle}</p>
          {sessionMessage && (
            <p className="rounded-md bg-amber-50 px-3 py-2 text-sm text-amber-700">
              {sessionMessage || authCopy.login.sessionExpiredMessage}
            </p>
          )}
          <form className="space-y-4" onSubmit={handleSubmit}>
            <div>
              <label className="text-sm font-medium text-slate-700">
                {authCopy.login.fields.phoneLabel}
              </label>
              <input
                className="mt-2 w-full rounded-md border border-slate-200 px-3 py-2 text-sm"
                placeholder={authCopy.login.fields.phonePlaceholder}
                value={email}
                onChange={(event) => setEmail(event.target.value)}
                type="email"
                autoComplete="email"
                aria-label={authCopy.login.fields.phoneLabel}
              />
            </div>
            <div>
              <label className="text-sm font-medium text-slate-700">
                {authCopy.login.fields.passwordLabel}
              </label>
              <input
                className="mt-2 w-full rounded-md border border-slate-200 px-3 py-2 text-sm"
                placeholder={authCopy.login.fields.passwordPlaceholder}
                type="password"
                value={password}
                onChange={(event) => setPassword(event.target.value)}
              />
            </div>
            {error && <p className="text-sm text-rose-500">{error}</p>}
            <button
              className="btn btn-primary w-full"
              disabled={!isValid || isSubmitting}
            >
              {authCopy.login.submitLabel}
            </button>
            {isSubmitting && (
              <p className="text-xs text-slate-500">{authCopy.login.loading}</p>
            )}
            <p className="text-xs text-slate-500">{authCopy.login.helper}</p>
          </form>
          <p className="text-sm text-slate-600">
            {authCopy.login.footerPrompt}{" "}
            <NavLink to="/signup" className="text-amber-600">
              {authCopy.login.footerLinkLabel}
            </NavLink>
          </p>
        </div>
      </section>
    </div>
  );
}
